/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import { NgModule } from '@angular/core';
import { FcAgLoadingMaskComponent } from './fc-ag-loading-mask.component';
import {FcAgLoadingMaskHolderComponent} from './fc-ag-loading-mask-holder.component';

/**
 * Loading mask component with Angular.
 */
@NgModule({
    declarations: [
        FcAgLoadingMaskComponent,
        FcAgLoadingMaskHolderComponent
    ],
    imports: [],
    exports: [
        FcAgLoadingMaskComponent,
        FcAgLoadingMaskHolderComponent
    ]
})

export class FcAgLoadingMaskModule {
}
